'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _lib = require('helpers/lib');

var _reactRedux = require('react-redux');

var _leftBackground3x = require('assets/img/membership/leftBackground@3x.png');

var _leftBackground3x2 = _interopRequireDefault(_leftBackground3x);

var _rightBackground3x = require('assets/img/membership/rightBackground@3x.png');

var _rightBackground3x2 = _interopRequireDefault(_rightBackground3x);

var _upperLeftDecor3x = require('assets/img/membership/upperLeftDecor@3x.png');

var _upperLeftDecor3x2 = _interopRequireDefault(_upperLeftDecor3x);

var _upperRightDecor3x = require('assets/img/membership/upperRightDecor@3x.png');

var _upperRightDecor3x2 = _interopRequireDefault(_upperRightDecor3x);

var _bottomLeftDecor3x = require('assets/img/membership/bottomLeftDecor@3x.png');

var _bottomLeftDecor3x2 = _interopRequireDefault(_bottomLeftDecor3x);

var _bottomRightDecor3x = require('assets/img/membership/bottomRightDecor@3x.png');

var _bottomRightDecor3x2 = _interopRequireDefault(_bottomRightDecor3x);

var _lookmePoint3x = require('assets/img/membership/lookmePoint@3x.png');

var _lookmePoint3x2 = _interopRequireDefault(_lookmePoint3x);

var _benefitBackground = require('assets/img/membership/benefitBackground.png');

var _benefitBackground2 = _interopRequireDefault(_benefitBackground);

var _benefitItemIcon = require('assets/img/membership/benefitItemIcon.png');

var _benefitItemIcon2 = _interopRequireDefault(_benefitItemIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lookmeSilver = 'https://minio.lookme.vn/assets/banner-thanh-vien-bac-lookme.vn-3x.jpg';
var lookmeGold = 'https://minio.lookme.vn/assets/banner-thanh-vien-vang-lookme.vn-3x.jpg';
var lookmeDiamond = 'https://minio.lookme.vn/assets/banner-thanh-vien-kim-cuong-lookme.vn-3x.jpg';
var tabs = [{
  type: 'silver',
  title: 'Hạng Bạc',
  img: lookmeSilver,
  no: 0
}, {
  type: 'gold',
  title: 'Hạng Vàng',
  img: lookmeGold,
  no: 1
}, {
  type: 'diamond',
  title: 'Kim Cương',
  img: lookmeDiamond,
  no: 2
}];
var MembershipBenefit = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MembershipBenefit, _Component);

  function MembershipBenefit(props) {
    (0, _classCallCheck3.default)(this, MembershipBenefit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MembershipBenefit.__proto__ || (0, _getPrototypeOf2.default)(MembershipBenefit)).call(this, props));

    _this.state = {
      selected: {
        type: 'silver',
        title: 'Hạng Bạc',
        img: lookmeSilver,
        no: 0
      }
    };

    _this.handleSelectTab = _this.handleSelectTab.bind(_this);
    _this.renderRankTabs = _this.renderRankTabs.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MembershipBenefit, [{
    key: 'getNo',
    value: function getNo(userRank) {
      var tab = tabs.find(function (v) {
        return v.type === userRank;
      });
      return tab ? tab.no : -1;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var user = this.props.user;

      this.userNo = user && user.rank ? this.getNo(user.rank) : -1;
    }
  }, {
    key: 'handleSelectTab',
    value: function handleSelectTab(selected) {
      this.setState({ selected: selected });
    }
  }, {
    key: 'renderRankTabs',
    value: function renderRankTabs(item, index) {
      var _this2 = this;

      var selected = this.state.selected;

      var styles = require('./MembershipBenefit.scss');
      var rankTab = styles.rankTab;
      if (item.type === selected.type) {
        rankTab = rankTab + ' ' + styles.selected;
      }
      if (item.no <= this.userNo) {
        rankTab = rankTab + ' ' + styles.achieved;
      }
      return _react2.default.createElement(
        'span',
        {
          className: rankTab,
          onClick: function onClick() {
            return _this2.handleSelectTab(item);
          },
          key: 'tabRank_' + index
        },
        _react2.default.createElement('i', { className: styles.rankIcon + ' fa fa-check-circle' }),
        item.title
      );
    }
  }, {
    key: 'toReward',
    value: function toReward() {}
  }, {
    key: 'styles',
    value: function styles(type) {
      var styles = require('./MembershipBenefit.scss');
      var style = {
        membershipBadge: styles.membershipBadge
      };
      switch (type) {
        case 'new':
          style.membershipBadge = styles.membershipBadge + ' ' + styles.new;
          break;
        case 'silver':
          style.membershipBadge = styles.membershipBadge + ' ' + styles.silver;
          break;
        case 'gold':
          style.membershipBadge = styles.membershipBadge + ' ' + styles.gold;
          break;
        case 'diamond':
          style.membershipBadge = styles.membershipBadge + ' ' + styles.diamond;
          break;
        default:
          break;
      }
      return style;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./MembershipBenefit.scss');
      var selected = this.state.selected;
      var user = this.props.user;

      var progressPercentage = 0;
      var objRank = user.objectRank || {};
      var styleByType = this.styles();
      if (objRank && objRank.type) {
        styleByType = this.styles(user.rank);
        progressPercentage = user.totalPoints / (objRank.nextPoint - objRank.point) * 100;
      }
      var avatarUrl = user.profile.picture ? (0, _lib.getUrlImage)(user.profile.picture) : _Constant.defaultAvatar;
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.generalInfoContainer },
          _react2.default.createElement(
            'div',
            { className: styles.avatarContainer },
            _react2.default.createElement('img', {
              src: avatarUrl,
              style: { backgroundImage: 'url:(' + avatarUrl + ')' },
              className: styles.avatarImg
            }),
            _react2.default.createElement('img', {
              src: _upperLeftDecor3x2.default,
              style: { backgroundImage: 'url:(' + _upperLeftDecor3x2.default + ')' },
              className: styles.upperLeftDecor
            }),
            _react2.default.createElement('img', {
              src: _upperRightDecor3x2.default,
              style: { backgroundImage: 'url:(' + _upperRightDecor3x2.default + ')' },
              className: styles.upperRightDecor
            }),
            _react2.default.createElement('img', {
              src: _bottomLeftDecor3x2.default,
              style: { backgroundImage: 'url:(' + _bottomLeftDecor3x2.default + ')' },
              className: styles.bottomLeftDecor
            }),
            _react2.default.createElement('img', {
              src: _bottomRightDecor3x2.default,
              style: { backgroundImage: 'url:(' + _bottomRightDecor3x2.default + ')' },
              className: styles.bottomRightDecor
            })
          ),
          _react2.default.createElement('img', {
            src: _leftBackground3x2.default,
            style: { backgroundImage: 'url:(' + _leftBackground3x2.default + ')' },
            className: styles.leftBackground
          }),
          _react2.default.createElement('img', {
            src: _rightBackground3x2.default,
            style: { backgroundImage: 'url:(' + _rightBackground3x2.default + ')' },
            className: styles.rightBackground
          }),
          _react2.default.createElement(
            'span',
            { className: styleByType.membershipBadge },
            objRank.label
          ),
          _react2.default.createElement(
            'div',
            { className: styles.exuContainer },
            user.totalPoints,
            _react2.default.createElement('img', {
              src: _lookmePoint3x2.default,
              style: { backgroundImage: 'url:(' + _lookmePoint3x2.default + ')' },
              className: styles.exu
            })
          ),
          _react2.default.createElement(
            'span',
            { className: styles.exchangePoint, onClick: this.toReward },
            '\u0110\u1ED5i \u0111i\u1EC3m t\xEDch lu\u1EF9',
            _react2.default.createElement('i', { className: styles.exchangePointIcon + ' fa fa-angle-right' })
          )
        ),
        objRank && objRank.type && objRank.type !== 'diamond' && _react2.default.createElement(
          'div',
          { className: styles.progressBarWrap },
          _react2.default.createElement(
            'div',
            { className: styles.progressBarInnerWrap },
            _react2.default.createElement(
              'span',
              { className: styles.progressBarInfoWrap },
              'B\u1EA1n c\xF2n\xA0',
              _react2.default.createElement(
                'span',
                { className: styles.progressBarExuWrap },
                objRank.nextPoint - user.totalPoints,
                '\xA0',
                _react2.default.createElement('img', {
                  src: _lookmePoint3x2.default,
                  style: { backgroundImage: 'url:(' + _lookmePoint3x2.default + ')' },
                  className: styles.progressBarExu
                })
              ),
              '\xA0\u0111\u1EC3 l\xEAn h\u1EA1ng\xA0',
              _react2.default.createElement(
                'span',
                { className: styles.nextRank },
                'B\u1EA1c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.progressBar },
              _react2.default.createElement(
                'div',
                {
                  className: styles.leftCircle,
                  style: { borderColor: _Constant2.default.RANK[objRank.type].begin }
                },
                _react2.default.createElement(
                  'span',
                  { className: styles.prevRankPoint },
                  objRank.point,
                  _react2.default.createElement('img', {
                    src: _lookmePoint3x2.default,
                    style: { backgroundImage: 'url:(' + _lookmePoint3x2.default + ')' },
                    className: styles.progressBarExu
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.centerBar },
                _react2.default.createElement('div', {
                  className: styles.activeProgressBar,
                  style: { width: progressPercentage + '%' }
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.rightCircle,
                  style: { borderColor: _Constant2.default.RANK[objRank.type].end }
                },
                _react2.default.createElement(
                  'span',
                  { className: styles.nextRankPoint },
                  objRank.nextPoint,
                  _react2.default.createElement('img', {
                    src: _lookmePoint3x2.default,
                    style: { backgroundImage: 'url:(' + _lookmePoint3x2.default + ')' },
                    className: styles.progressBarExu
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.benefitWrap },
          _react2.default.createElement(
            'div',
            { className: styles.benefitInnerWrap },
            _react2.default.createElement(
              'div',
              { className: styles.rankList },
              tabs.map(function (item, index) {
                return _this3.renderRankTabs(item, index);
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.benefitInfoWrap },
              _react2.default.createElement('img', {
                src: selected.img,
                style: { backgroundImage: 'url:(' + _benefitBackground2.default + ')' },
                className: styles.benefitBackground
              }),
              _react2.default.createElement(
                'div',
                { className: styles.benefitInfo },
                _react2.default.createElement(
                  'span',
                  { className: styles.benefitTitle },
                  _Constant2.default.RANK[selected.type].titleBenefit
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.benefitContent },
                  _Constant2.default.RANK[selected.type].benefit.map(function (item) {
                    return _react2.default.createElement(
                      'span',
                      { className: styles.benefitInfoItem },
                      _react2.default.createElement('img', {
                        src: _benefitItemIcon2.default,
                        style: { backgroundImage: 'url:(' + _benefitItemIcon2.default + ')' },
                        className: styles.benefitItemIcon
                      }),
                      item
                    );
                  }),
                  selected.no <= this.userNo && _react2.default.createElement(
                    'span',
                    { className: styles.unlockContainer },
                    _react2.default.createElement('i', {
                      className: styles.unlockIcon + ' fa fa-check-circle'
                    }),
                    'B\u1EA1n \u0111\xE3 m\u1EDF kho\xE1 \u0111\u01B0\u1EE3c th\u1EE9 h\u1EA1ng n\xE0y'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return MembershipBenefit;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  history: _react.PropTypes.object
}, _temp)) || _class);
exports.default = MembershipBenefit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/AccountManagement/MembershipBenefit.js
// module id = 1528
// module chunks = 0